import api from "../../../../services/api"
import { IReasonList } from "./types";

export const getReasonList = async (signal: AbortSignal) =>
    (await api.get<IReasonList>('/schedulling/occurrence/reason', { signal })).data;